<template>
  <div>
    <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div class="text-introduce">
            <h3>出版单位从业人员总体情况</h3>
            <p>
              出版单位职工总数：<span class="numStyle">{{ workerBaseInfo.workers }}</span> 人
            </p>
            <p>
              音像制品从业人员总数：<span class="numStyle">{{ workerBaseInfo.businessworkersyx }}</span> 人
            </p>
            <p>
              电子出版物从业人员总数：<span class="numStyle">{{ workerBaseInfo.businessworkersdz }}</span>
              人
            </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="base_chart" style="height: 233px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div class="text-introduce">
            <h3>人员构成</h3>
            <p>
              领导班子：音像
              <span class="numStyle">{{ workerBaseInfo.businessleaderyx }}</span> 人，电子
              <span class="numStyle">{{ workerBaseInfo.businessleaderdz }}</span> 人
            </p>
            <p>
              编辑人员：音像 <span class="numStyle">{{ workerBaseInfo.totalworkeryx }}</span> 人，电子
              <span class="numStyle">{{ workerBaseInfo.totalworkerdz }}</span> 人
            </p>
            <p>
              制作加工人员： 音像
              <span class="numStyle">{{ workerBaseInfo.pepnumprocessyx }}</span> 人， 电子
              <span class="numStyle">{{ workerBaseInfo.pepnumprocessdz }}</span> 人
            </p>
            <p>
              新媒体、网络运营等技术人员：音像
              <span class="numStyle">{{ workerBaseInfo.pepnuminternationyx }}</span> 人，电子
              <span class="numStyle">{{ workerBaseInfo.pepnuminternationdz }}</span> 人
            </p>
            <p>
              专职出版物发行人员：音像
              <span class="numStyle">{{ workerBaseInfo.pepnumissueyx }}</span> 人，电子
              <span class="numStyle">{{ workerBaseInfo.pepnumissuedz }}</span> 人
            </p>
            <p>
              其他人员：音像
              <span class="numStyle">{{ workerBaseInfo.pepnumotheryx }}</span> 人，电子
              <span class="numStyle">{{ workerBaseInfo.pepnumotherdz }}</span> 人
            </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="member_chart" style="height: 358.4px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" style="padding: 15px 15px 0px 0px">
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="member_pie_media" style="height: 274px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="member_pie_electr" style="height: 274px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");
import vintage from "echarts/theme/vintage.js";
import macarons from "echarts/theme/macarons.js";
import macarons2 from "echarts/theme/macarons2.js";
import blue from "echarts/theme/blue.js";
import cool from "echarts/theme/cool.js";
import forest from "echarts/theme/forest.js";
import fruit from "echarts/theme/fruit.js";
import green from "echarts/theme/green.js";
import roma from "echarts/theme/roma.js";
import shine from "echarts/theme/shine.js";
import london from "echarts/theme/london.js";
import infographic from "echarts/theme/infographic.js";

import { getWorkerBaseInfo } from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      yearsOptions: [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024],
      provinceOptions: [],
      limitsOptions: [
        { text: "前10", value: 10 },
        { text: "前20", value: 20 },
        { text: "全部", value: 0 },
      ],

      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: 2021,
      targetprovince: [],
      targetlimit: 0,

      datalist: [],

      query: {},
      bakData: {},

      workerBaseInfo: {},
      chartDataBase: [],
      chartDataFinance: [],
    };
  },
  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler(val) {
        this.chartTheme = val;
        console.log("chartTheme====", this.activeName);
        if (this.activeName == "worker") {
          setTimeout(
            function () {
              this.drawBaseCharts();
              this.drawMemberCharts();
              this.drawMemberPieElectr();
              this.drawMemberPieMedia();
            }.bind(this),
            1000
          );
        }
      },
      immediate: true,
    },
    activeName: {
      handler(val) {
        if (val == "worker") {
          var baseChart = echarts.init(document.getElementById("base_chart"), this.chartTheme);
          this.chartResize(baseChart);
          var memberChart = echarts.init(document.getElementById("member_chart"), this.chartTheme);
          this.chartResize(memberChart);
          var memberPieElectr = echarts.init(document.getElementById("member_pie_electr"), this.chartTheme);
          this.chartResize(memberPieElectr);
          var memberPieMedia = echarts.init(document.getElementById("member_pie_media"), this.chartTheme);
          this.chartResize(memberPieMedia);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async downloadData(id) {
      var columns = { provincename: "省局", name: "出版单位", value: this.category };
      let cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
      var list = [];
      for (var i in this.datalist) {
        var po = this.datalist[i];
        var data = {};
        for (var key in columns) {
          data[columns[key]] = po[key];
        }
        list.push(data);
      }
      var filename = `${this.targetyear}年${this.category}_${moment()}.xlsx`;
      var opts = Object.values(columns);
      var wsname = "Sheet1";
      const wb = XLSX.utils.book_new();
      const ws = await XLSX.utils.json_to_sheet(list, opts);
      ws["!cols"] = cellWidths;
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      await XLSX.writeFile(wb, `${filename}`);
    },
    initCharts() {
      this.goSearchworkerCharts();
    },
    createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      let html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html +=
          ' <td style="text-align: center; vertical-align: middle;width:30px;padding: 0.74rem;">' +
          (Number(index) + 1) +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;width: 190px;padding: 0.74rem;">' +
          item.provincename +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;width: 230px;padding: 0.74rem;">' + item.name + "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' +
          this.formatEmpty(item.value) +
          "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchworkerCharts() {
      var that = this;
      getWorkerBaseInfo({ firstyear: this.searchFirstYear }).then((res) => {
        console.log("getWorkerBaseInfo====", res);
        that.workerBaseInfo = res.base[0];

        setTimeout(function () {
          that.drawBaseCharts();
          that.drawMemberCharts();
          that.drawMemberPieElectr();
          that.drawMemberPieMedia();
        }, 1000);
      });
    },
    drawBaseCharts() {
      this.disposeChart("base_chart");
      var myChart = echarts.init(document.getElementById("base_chart"), this.chartTheme);
      var option = {
        grid: {
          top: "50px",
          left: "15%",
          bottom: "50px",
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: ["职工总数", "音像", "电子"],
        },
        series: [
          {
            type: "bar",
            avoidLabelOverlap: false,
            // color:['#4FA1F3','#C976F4'],
            data: [
              {
                value: this.workerBaseInfo.workers,
                itemStyle: {
                  color: myChart._theme.color[2],
                },
              },
              {
                value: this.workerBaseInfo.businessworkersyx,
                itemStyle: {
                  color: myChart._theme.color[0],
                },
              },
              {
                value: this.workerBaseInfo.businessworkersdz,
                itemStyle: {
                  color: myChart._theme.color[1],
                },
              },
            ],
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    drawMemberCharts() {
      console.log("drawMemberCharts", this.workerBaseInfo);
      this.disposeChart("member_chart");
      var myChart = echarts.init(document.getElementById("member_chart"), this.chartTheme);
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: "10px",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: ["领导班子", "编辑", "制作加工", "技术人员", "出版物发行", "其他(包含行政人员)"],
        },
        series: [
          {
            name: "音像",
            type: "bar",
            data: [
              this.workerBaseInfo.businessleaderyx,
              this.workerBaseInfo.totalworkeryx,
              this.workerBaseInfo.pepnumprocessyx,
              this.workerBaseInfo.pepnuminternationyx,
              this.workerBaseInfo.pepnumissueyx,
              this.workerBaseInfo.pepnumotheryx,
            ],
          },
          {
            name: "电子",
            type: "bar",
            data: [
              this.workerBaseInfo.businessleaderdz,
              this.workerBaseInfo.totalworkerdz,
              this.workerBaseInfo.pepnumprocessdz,
              this.workerBaseInfo.pepnuminternationdz,
              this.workerBaseInfo.pepnumissuedz,
              this.workerBaseInfo.pepnumotherdz,
            ],
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    drawMemberPieMedia() {
      this.disposeChart("member_pie_media");
      var myChart = echarts.init(document.getElementById("member_pie_media"), this.chartTheme);
      var option = {
        title: {
          text: "音像制品从业人员比例",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "人员占比",
            type: "pie",
            radius: "50%",
            data: [
              { value: this.workerBaseInfo.businessleaderyx, name: "领导班子" },
              { value: this.workerBaseInfo.totalworkeryx, name: "编辑人员" },
              { value: this.workerBaseInfo.pepnumprocessyx, name: "制作加工" },
              { value: this.workerBaseInfo.pepnuminternationyx, name: "技术人员" },
              { value: this.workerBaseInfo.pepnumissueyx, name: "发行人员" },
              { value: this.workerBaseInfo.pepnumotheryx, name: "其他(包含行政人员)" },
            ],
            label: {
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "edge",
              minMargin: 5,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    drawMemberPieElectr() {
      this.disposeChart("member_pie_electr");
      var myChart = echarts.init(document.getElementById("member_pie_electr"), this.chartTheme);
      var option = {
        title: {
          text: "电子出版物从业人员比例",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "人员占比",
            type: "pie",
            radius: "50%",
            data: [
              { value: this.workerBaseInfo.businessleaderdz, name: "领导班子" },
              { value: this.workerBaseInfo.totalworkerdz, name: "编辑人员" },
              { value: this.workerBaseInfo.pepnumprocessdz, name: "制作加工" },
              { value: this.workerBaseInfo.pepnuminternationdz, name: "技术人员" },
              { value: this.workerBaseInfo.pepnumissuedz, name: "发行人员" },
              { value: this.workerBaseInfo.pepnumotherdz, name: "其他(包含行政人员)" },
            ],
            label: {
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "edge",
              minMargin: 5,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    drawAnimeBar: function (id, chartParams) {
      console.log("drawAnimeBar", chartParams);
      let that = this;
      this.disposeChart(id);

      var maxCount = this.targetlimit;
      if (maxCount == 0) {
        maxCount = chartParams.provinceList.length - 1;
      }

      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          subtext: chartParams.subtext,
          left: "center",
          top: 50,
        },
        tooltip: {
          trigger: "item",
        },
        grid: { top: "15%", left: "27%" },
        legend: {
          show: true,
          bottom: "10",
        },
        xAxis: {
          gridIndex: 0,
          max: "dataMax",
          min: 0,
          axisLabel: {
            show: false,
            interval: 5,
            hideOverlap: true,
            showMaxLabel: true,
          },
          position: "top",
          name: "万元",
        },
        yAxis: {
          type: "category",
          gridIndex: 0,
          data: chartParams.provinceList,
          inverse: true,
          animationDuration: 300,
          animationDurationUpdate: 300,
          max: maxCount,
        },
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "搜索筛选", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 50,
          right: 10,
        },
        animationDuration: 0,
        animationDurationUpdate: 1000,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("clickparams==", id, params);
        var title = params.seriesName.substr(5);
        if (id == "chart_province_1") {
          that.table1colname = title;
        } else if (id == "chart_province_2") {
          that.table2colname = title;
        } else if (id == "chart_province_3") {
          that.table3colname = title;
        }

        console.log(params);
      });
      this.chartResize(myChart);
    },
    chartResize(myChart) {
      myChart.resize();
    },
    backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible(id) {
      this.queryVisible[id] = !this.queryVisible[id];
    },
    goFilterList(id) {
      console.log("goFilterList", this.query);
      var query = this.query[id];
      var datalist = this.bakData[id];

      var filtedData = datalist.filter((item) => {
        return (
          item.provincename.indexOf(query.provincename) > -1 &&
          item.name.indexOf(query.name) > -1 &&
          (item.value + "").indexOf(query.value) > -1
        );
      });
      this.createDataHtml(id, filtedData);
    },
    formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    },
  },
  created: function () {
    let that = this;
    window.addEventListener("resize", () => {
      that.initCharts();
    });
    that.initCharts();
  },
};
</script>

<style lang="scss" scoped>
.echart_table {
  width: 90%;
  overflow: hidden;
  display: none;
  margin-top: 60px;
}

.tabletemp {
  width: 90%;
  height: 760px;
}

.echart_table table tbody {
  display: block;
  height: 660px;
  overflow-y: auto;
}

.echart_table .tabletemp th {
  padding: 0.24rem;
}

.searchFilerCls {
  padding-top: 3px;
}

.text-introduce {
  padding: 20px 24px 24px 30px;
}

.numStyle {
  color: red;
  font-weight: bold;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// WorkerBase.vue?2f183a20